import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { getFileName, getFileType, MAX_TOTAL_EMAIL_MESSAGE_SIZE_BYTES } from '../../..';
import { MAX_FILE_SIZE_BYTES, MAX_FILES_PER_MESSAGE } from '../constants';
import { validateFiles } from '../validations';
import { FileItemThumbnail } from './file-item-thumbnail';
export const FilePickerNode = ({ onError, fileInputRef, currentFiles, setCurrentFiles, onChange, accept, }) => {
    const addFiles = useCallback((files) => {
        setCurrentFiles?.((prev) => [...prev, ...files]);
    }, [setCurrentFiles]);
    const handleDelete = useCallback((index) => {
        setCurrentFiles?.((prev) => prev.toSpliced(index, 1));
    }, [setCurrentFiles]);
    const handleFileChange = useCallback((event) => {
        const { target } = event;
        if (!target?.files) {
            return;
        }
        const files = Array.from(target.files);
        const notRepeatedFiles = files.filter((file) => !currentFiles?.find((f) => file.name === getFileName(f) &&
            file.size === f.size &&
            file.type === getFileType(f)));
        if (!notRepeatedFiles.length) {
            return;
        }
        const validationResult = validateFiles([...notRepeatedFiles, ...(currentFiles || [])], {
            maxFiles: MAX_FILES_PER_MESSAGE,
            maxFileSize: MAX_FILE_SIZE_BYTES,
            maxTotalFilesSizeBytes: MAX_TOTAL_EMAIL_MESSAGE_SIZE_BYTES,
        });
        if (!validationResult.valid) {
            onError?.(validationResult.message);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            return;
        }
        try {
            addFiles(notRepeatedFiles);
        }
        catch (e) {
            console.error(e);
            onError?.('Something went wrong attaching the files, please try again later');
        }
        finally {
            /**
             * next change event might not be triggered because the file input value hasn't
             * technically changed if selecting the same file again.
             * To ensure the change event is always triggered, so resetting the value
             * */
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    }, [addFiles, currentFiles, fileInputRef, onError]);
    return (_jsxs(_Fragment, { children: [_jsx("input", { type: "file", multiple: true, style: {
                    position: 'absolute',
                    width: 1,
                    height: 1,
                    padding: 0,
                    margin: -1,
                    overflow: 'hidden',
                    clip: 'rect(0, 0, 0, 0)',
                    whiteSpace: 'nowrap',
                    border: 0,
                }, accept: accept, ref: fileInputRef, onChange: onChange ?? handleFileChange }), !!currentFiles?.length && (_jsx("div", { className: "file-list-thumbnails-container", children: currentFiles.map((file, index) => (_jsx(FileItemThumbnail, { file: file, onDelete: handleDelete, index: index }, getFileName(file) + file.size + getFileType(file)))) }))] }));
};
